import React from 'react';
import PropTypes from 'prop-types';
import { resolutionDate } from '../utilities/poaRequests';

const ProcessingBanner = ({
  status,
  header,
  accepted,
  copy,
  date,
  representative,
}) => {
  return (
    <va-alert status={status} visible className="poa__alert">
      <h2>{header}</h2>
      <p className="vads-u-margin-y--0">
        {accepted && (
          <span className="processing-date vads-u-display--block vads-u-margin-y--2">
            {representative} {accepted} {resolutionDate(date)}.
          </span>
        )}
        {copy}
      </p>
    </va-alert>
  );
};

ProcessingBanner.propTypes = {
  accepted: PropTypes.string,
  copy: PropTypes.string,
  date: PropTypes.string,
  header: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  representative: PropTypes.string,
  status: PropTypes.string,
};

export default ProcessingBanner;
